// @flow
import { DocumentosActionTypes } from './constants';

type DocumentosAction = { type: string, payload: {} | string };

// common success
export const documentosApiResponseSuccess = (actionType: string, data: any): DocumentosAction => ({
    type: DocumentosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const documentosApiResponseError = (actionType: string, error: string): DocumentosAction => ({
    type: DocumentosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getDocumento = (id: string): DocumentosAction => ({
    type: DocumentosActionTypes.GET_DOCUMENTO,
    payload: { id },
});

export const addDocumento = (documento:any):DocumentosAction=>({
    type:DocumentosActionTypes.ADD_DOCUMENTO,
    payload:documento
})
export const updateDocumento = (documento:any):DocumentosAction=>({
    type:DocumentosActionTypes.UPDATE_DOCUMENTO,
    payload:documento
})
export const deleteDocumento = (id:string):DocumentosAction=>({
    type:DocumentosActionTypes.DELETE_DOCUMENTO,
    payload:{id}
})

export const listDocumentos = (params:any): DocumentosAction => ({
    type: DocumentosActionTypes.LIST_DOCUMENTOS,
    payload: params,
});

export const listDocumentosPreview = (params:any): DocumentosAction => ({
    type: DocumentosActionTypes.LIST_DOCUMENTOS_PREVIEW,
    payload: params,
});

export const getDocumentoPreview = (id: string): DocumentosAction => ({
    type: DocumentosActionTypes.GET_DOCUMENTO_PREVIEW,
    payload: { id },
});

export const setFiltersDocumentos = (params:any): DocumentosAction => ({
    type: DocumentosActionTypes.SET_FILTER,
    payload: params,
})

export const resetDocumentos = (): DocumentosAction => ({
    type: DocumentosActionTypes.RESET,
    payload: {},
});

